import { Tabs } from 'antd'
import React from 'react'

import { Role, useGetViewerQuery } from '@/generated/graphql'

import s from './kpi.module.less'
import { MonitorContainer } from './monitor/monitor.container'
import { StatisticsContainer } from './statistics/statistics.container'

const KPITab = { statistics: '统计维度', monitor: '监控指标' }
type KPITabType = keyof typeof KPITab

export const KPIContainer: React.FC = () => {
  const [tab, setTab] = React.useState<KPITabType>('statistics')
  const { data: userData } = useGetViewerQuery()

  if (
    !userData ||
    !userData.viewer.roles.some((role) => role.role === Role.RootAdmin || role.role === Role.SystemAdmin)
  ) {
    return null
  }

  const tabs = (
    <Tabs activeKey={tab} onChange={(key) => setTab(key as typeof tab)}>
      {Object.keys(KPITab).map((key) => (
        <Tabs.TabPane tab={KPITab[key]} key={key} />
      ))}
    </Tabs>
  )

  const content = (() => {
    switch (tab) {
      case 'statistics':
        return <StatisticsContainer />
      case 'monitor':
        return <MonitorContainer />
    }
  })()

  return (
    <div className={s.kpiContainer}>
      {tabs}
      {content}
    </div>
  )
}
